/**
 * CareTeam schemas — access compartment / provider panel.
 *
 * Enum arrays are tied to fhir-model types via `satisfies`.
 */
import { z } from 'zod';
import type {
  CareTeamStatus as FhirCareTeamStatus,
  ParticipationRoleCode as FhirParticipationRoleCode,
} from '@unify/fhir-model/resources/care-team';

/** FHIR CareTeam.status values — synced with fhir-model. */
export const careTeamStatusValues = [
  'active',
  'inactive',
  'entered-in-error',
] as const satisfies readonly FhirCareTeamStatus[];

/** Participant role codes — synced with fhir-model. */
export const participationRoleCodeValues = [
  'PPRF',
  'SPRF',
] as const satisfies readonly FhirParticipationRoleCode[];

/**
 * Assign a provider to a patient's CareTeam.
 */
export const careTeamAssignmentSchema = z.object({
  patientId: z.string().min(1, 'Patient is required'),
  practitionerId: z.string().min(1, 'Provider is required'),
  role: z.enum(participationRoleCodeValues),
  organizationId: z.string().min(1, 'Organization is required'),
});

export type CareTeamAssignmentInput = z.infer<typeof careTeamAssignmentSchema>;
